import { Link } from "react-router-dom";

export function Logo() {
  return (
    <Link className="brand" to="/" aria-label="SideQuest HQ home">
      <span className="brand-mark" aria-hidden="true">
        <img src="/brand-logo.png" alt="" width={38} height={38} decoding="async" draggable={false} />
      </span>
      <span>SideQuest <strong>HQ</strong></span>
    </Link>
  );
}
